var _defs, _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRhmUdmBg = function SvgRhmUdmBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920,
    height: 320
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "rhm-udm-bg_svg__b",
    cx: 0.5,
    cy: 0.5,
    r: 0.511,
    gradientTransform: "matrix(1 0 0 1.856 0 -.428)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777986",
    stopOpacity: 0.204
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rhm-udm-bg_svg__a",
    x1: 1,
    x2: 0.012,
    y1: 0.107,
    y2: 0.933,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#777986",
    stopOpacity: 0.204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.204
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1920v320H0z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 320,
    fill: "url(#rhm-udm-bg_svg__a)",
    rx: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 320,
    fill: "url(#rhm-udm-bg_svg__b)",
    rx: 3
  })));
};
export default SvgRhmUdmBg;